export default {"src":"/login-app/[GIT_HASH]/_next/static/media/thumb_down.e772bc59.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};